export default ($) => {
	let fbUserIcons = $('.fts-jal-fb-user-thumb a img');
	let fbUserNames = $('.fts-jal-fb-user-name a');
	let fbPosts = $('.fts-jal-single-fb-post');

	// change the alt text for the Facebook user icons
	for (let ico = 0; ico < fbUserIcons.length; ico++) {
		let tmpAlt = $(fbUserIcons[ico]).attr('alt');
		let newAlt = 'Facebook Profile: ' + tmpAlt;
		$(fbUserIcons[ico]).attr('alt', newAlt);
	}

	// change the link text for the Facebook usernames
	for (let fbn = 0; fbn < fbUserNames.length; fbn++) {
		let tmpTxt = $(fbUserNames[fbn]).html();
		let newTxt = '<span class="sr-only">Facebook Profile: </span>' + tmpTxt;
		$(fbUserNames[fbn]).html(newTxt);
	}

	// for each Facebook post, change the image alt text to use the post description text for each link, limited to 10 words
	for (let fbp = 0; fbp < fbPosts.length; fbp++) {
		let fbPostTxt = $(fbPosts[fbp]).find('.fts-jal-fb-message').first().text();
		let fbImgLinks = $(fbPosts[fbp]).find('.fts-album-photos-wrap a');
		let fbAltTxt;
		let fbAltLen;
		if (fbImgLinks.length > 1) {
			fbAltLen = 99;
		} else if (fbImgLinks.length === 1) {
			fbAltLen = 107;
		}
		if (fbAltLen) {
			let tmpTxt = fbPostTxt.slice(0, fbAltLen);
			let chkPeriod = tmpTxt.lastIndexOf('.');
			let chkExclaim = tmpTxt.lastIndexOf('!');
			let chkQuestion = tmpTxt.lastIndexOf('?');
			fbAltLen = Math.max(chkPeriod, chkExclaim, chkQuestion);
			fbAltTxt = fbPostTxt.slice(0, fbAltLen + 1);
		} else {
			fbAltTxt = fbPostTxt;
		}

		// if the post is an album, get the total items and set each link's aria label
		if (fbImgLinks.length > 1) {
			for (let fbALink = 0; fbALink < fbImgLinks.length; fbALink++) {
				let picNum = fbALink + 1;
				$(fbImgLinks[fbALink]).attr('aria-label', 'Facebook Album Picture ' + picNum + ': ' + fbAltTxt);
			}
		} else {
			$(fbImgLinks).children('img').attr('alt', 'Facebook Picture: ' + fbAltTxt);
		}
	}
}